import React, {FC} from 'react';

import cn from 'classnames';

import bem from 'client/services/bem';

import ErrorMessage, {ErrorMessageType} from 'client/common/inputs/error-message';
import RequiredLabel from 'client/common/inputs/required-label';

import {Translation} from 'client/models/language/types';

import cssModule from './password-input.module.scss';

const b = bem('password-input', {cssModule});

type Props = {
  label?: Translation;
  name?: string;
  className?: string;
  inputClassName?: string;
  value?: string;
  errorMessage?: ErrorMessageType;
  warning?: Translation;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  required?: boolean;
};

const PasswordInput: FC<Props> = React.memo((props) => {
  const {
    label = '',
    className = '',
    name = '',
    inputClassName = '',
    errorMessage = '',
    warning = '',
    required = false,
    ...inputProps
  } = props;

  return (
    <div className={cn(b({error: !!errorMessage, success: warning && !errorMessage}), className)}>
      {label && (
        <label htmlFor={name} className={b('label')}>
          {label}
        </label>
      )}
      <input
        {...inputProps}
        name={name}
        className={cn(b('field'), inputClassName)}
        type="password"
        aria-invalid={!!errorMessage}
      />
      {!errorMessage && required && <RequiredLabel />}
      {errorMessage && <ErrorMessage errorMessage={errorMessage} />}
      {warning && !errorMessage && <p className={b('success-message')}>{warning}</p>}
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
